import React from 'react';
import { Button, Empty, Input } from 'antd';
import { BsPlusLg } from 'react-icons/bs';
import { PageLoader } from '@pages/api-portal/page-loader';
import { useGroupsManager } from './use-groups-manager';
import { GroupCard } from './group-card';
import { GroupFormDialog } from './group-dialog';

/*
 * API Groups manager — search, create/edit/delete groups used to organize catalog endpoints.
 */
export function GroupsManager() {
    const {
        filteredGroups,
        endpointCounts,
        isLoading,
        searchQuery,
        setSearchQuery,
        isFormDialogOpen,
        setIsFormDialogOpen,
        selectedGroup,
        isSubmitting,
        openCreateDialog,
        openEditDialog,
        handleSubmit,
        handleDeleteRequest,
    } = useGroupsManager();

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
                <Input.Search
                    placeholder="Search groups"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ maxWidth: 320 }}
                    allowClear
                />
                <Button type="primary" onClick={openCreateDialog}>
                    <BsPlusLg style={{ marginRight: 6 }} />
                    Create Group
                </Button>
            </div>

            {isLoading ? (
                <PageLoader />
            ) : filteredGroups.length === 0 ? (
                <Empty description={searchQuery ? 'No groups match your search' : 'No API groups yet'}>
                    {!searchQuery && (
                        <Button onClick={openCreateDialog}>
                            <BsPlusLg style={{ marginRight: 6 }} />
                            Create Group
                        </Button>
                    )}
                </Empty>
            ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 12 }}>
                    {filteredGroups.map((group) => (
                        <GroupCard
                            key={String(group.id)}
                            group={group}
                            endpointCount={endpointCounts[group.groupKey ?? String(group.id)] ?? 0}
                            onEdit={openEditDialog}
                            onDelete={handleDeleteRequest}
                        />
                    ))}
                </div>
            )}

            <GroupFormDialog
                open={isFormDialogOpen}
                onClose={() => setIsFormDialogOpen(false)}
                onSubmit={handleSubmit}
                isSubmitting={isSubmitting}
                group={selectedGroup}
            />
        </div>
    );
}
